
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.9 3.457V.586a.586.586 0 10-1.171 0v2.871A1.74 1.74 0 000 5.195a1.74 1.74 0 001.729 1.738v7.481a.586.586 0 101.171 0v-7.48a1.74 1.74 0 001.73-1.74A1.74 1.74 0 002.9 3.457zm-.01 2.305H1.739a.567.567 0 010-1.133h1.153a.567.567 0 010 1.133zM15 5.195a1.74 1.74 0 00-1.729-1.738V.586a.586.586 0 10-1.171 0v2.871a1.74 1.74 0 00-1.729 1.738A1.74 1.74 0 0012.1 6.933v7.481a.586.586 0 101.171 0v-7.48A1.74 1.74 0 0015 5.194zm-1.738.567h-1.153a.567.567 0 010-1.133h1.153a.567.567 0 010 1.133zM8.086 9.219V.586a.586.586 0 10-1.172 0v8.633a1.74 1.74 0 00-1.728 1.738 1.74 1.74 0 001.728 1.738v1.72a.586.586 0 001.172 0v-1.72a1.74 1.74 0 001.728-1.738 1.74 1.74 0 00-1.728-1.738zm-.01 2.304H6.924a.567.567 0 010-1.132h1.152a.567.567 0 010 1.132z","fill":"#E2E8F0"}})])
          )
        }
      }
    